import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Users } from "lucide-react";

interface QuickAction {
  title: string;
  description: string;
  icon: any;
  action: () => void;
}

interface QuickActionsProps {
  actions: QuickAction[];
}

export function QuickActions({ actions }: QuickActionsProps) {
  return (
    <Card className="h-full">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Users className="h-5 w-5 text-primary" />
          Quick Actions
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 mt-4">
        {actions.map((action, index) => (
          <Card
            key={index}
            className="hover:shadow-sm transition-shadow cursor-pointer"
            onClick={action.action}
          >
            <CardContent className="p-3">
              <div className="flex items-start gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
                  <action.icon className="h-5 w-5 text-primary" />
                </div>
                <div className="flex-1">
                  <h4 className="font-medium text-foreground">
                    {action.title}
                  </h4>
                  <p className="text-sm text-muted-foreground mt-1">
                    {action.description}
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </CardContent>
    </Card>
  );
}
